export default __webpack_public_path__ + "static/media/img-use-02.b046d32b.jpg";